export default {
  base: {
    background: '#ffffff',
    chrome000: '#ffffff',
    chrome100: '#ececec',
    chrome200: '#6d6d6d',
    chrome300: '#282c34',
    chrome400: '#20232a',
    shadow: 'rgba(32, 35, 42, 0.4)',
    shadowLight: 'rgba(32, 35, 42, 0.2)',
    text: '#20232a',
    textLight: '#6d6d6d',
    textWhite: '#ffffff',
  },
  brand: {
    primary: '#61dafb',
    secondary: '#fee46e',
    tertiary: '#ebfafe',
  },
};
